import { groupEventsByTournament } from '..';
import { PublishedEventListItem, Market } from '../../@types';

type TournamentGroup = ReturnType<typeof groupEventsByTournament>[string];

type InPlayVirtuosoBaseItem = {
  id: string;
  tournamentKey: string;
  tournamentData: TournamentGroup;
};

export type InPlayVirtuosoHeaderItem = InPlayVirtuosoBaseItem & {
  type: 'header';
};

export type InPlayVirtuosoEventItem = InPlayVirtuosoBaseItem & {
  type: 'event';
  event: PublishedEventListItem;
};

export type InPlayVirtuosoItem = InPlayVirtuosoHeaderItem | InPlayVirtuosoEventItem;

export const buildInPlayVirtuosoItems = (
  events: PublishedEventListItem[],
  topMarkets: Record<string, Market[] | null>
): InPlayVirtuosoItem[] => {
  const eventsByTournament = groupEventsByTournament(events);
  const items: InPlayVirtuosoItem[] = [];

  Object.entries(eventsByTournament).forEach(([tournamentKey, tournamentData]) => {
    items.push({
      type: 'header',
      id: `header-${tournamentKey}`,
      tournamentKey,
      tournamentData,
    });

    tournamentData.events.forEach((event) => {
      const eventTopMarkets = topMarkets[event.id] ?? event.topMarkets;
      const eventWithTopMarkets = eventTopMarkets ? { ...event, topMarkets: eventTopMarkets } : event;

      items.push({
        type: 'event',
        id: `event-${event.id}`,
        tournamentKey,
        tournamentData,
        event: eventWithTopMarkets,
      });
    });
  });

  return items;
};
